var _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeOverview01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_14_1",
    "data-name": "Component 14 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1225,
    height: 586,
    viewBox: "0 0 1225 586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    fill: "#0f111a",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1199,
    height: 586,
    rx: 75,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1198,
    height: 585,
    rx: 74.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "import_React_from_react_import_Header_from_._Header_const_Menu_return_div_className_text-white_font-Poppins_text-_19px_h-_100vh_border-solid_border-white_border-_2px_flex_flex-col_Header_div_className_pl-",
    "data-name": "import React from 'react' import Header from './Header' const Menu = () => {   return (     <div className='text-white font-Poppins text-[19px] h-[100vh] border-solid border-white border-[2px] flex flex-col '>         <Header/>         <div className='pl-",
    transform: "translate(67 75)",
    fill: "#47b3eb",
    fontSize: 17,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "import"), /*#__PURE__*/React.createElement("tspan", {
    y: 18,
    fill: "#9a92a8"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 18,
    fill: "#cdc8d5"
  }, "React"), /*#__PURE__*/React.createElement("tspan", {
    y: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 18
  }, "from"), /*#__PURE__*/React.createElement("tspan", {
    y: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 18,
    fill: "#54b0e0"
  }, "&apos;"), /*#__PURE__*/React.createElement("tspan", {
    y: 18,
    fill: "#adc65b"
  }, "react"), /*#__PURE__*/React.createElement("tspan", {
    y: 18,
    fill: "#54b0e0"
  }, "&apos;"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#54b0e0"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 44
  }, "import"), /*#__PURE__*/React.createElement("tspan", {
    y: 44,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 44,
    fill: "#cdc8d5"
  }, "Header"), /*#__PURE__*/React.createElement("tspan", {
    y: 44,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 44
  }, "from &apos;"), /*#__PURE__*/React.createElement("tspan", {
    y: 44,
    fill: "#adc65b"
  }, "./Header"), /*#__PURE__*/React.createElement("tspan", {
    y: 44
  }, "&apos;")), /*#__PURE__*/React.createElement("tspan", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 70
  })), /*#__PURE__*/React.createElement("tspan", {
    fill: "#9846d8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 96
  }, "const"), /*#__PURE__*/React.createElement("tspan", {
    y: 96,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 96,
    fill: "#247fdb"
  }, "Menu"), /*#__PURE__*/React.createElement("tspan", {
    y: 96,
    xmlSpace: "preserve",
    fill: "#fff"
  }, " = () "), /*#__PURE__*/React.createElement("tspan", {
    y: 96
  }, "=&gt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 96,
    xmlSpace: "preserve",
    fill: "#fff"
  }, " {")), /*#__PURE__*/React.createElement("tspan", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 122,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 122,
    fill: "#47b3eb"
  }, "return"), /*#__PURE__*/React.createElement("tspan", {
    y: 122,
    xmlSpace: "preserve"
  }, " ("), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 148,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 148,
    fill: "#47b3eb"
  }, "&lt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 148
  }, "div "), /*#__PURE__*/React.createElement("tspan", {
    y: 148,
    fill: "#9846d8"
  }, "className"), /*#__PURE__*/React.createElement("tspan", {
    y: 148
  }, "=&apos;text-white font-Poppins text-[19px] h-[100vh] border-solid border-white border-[2px] flex flex-col &apos;&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 174,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 174,
    fill: "#47b3eb"
  }, "&lt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 174
  }, "Header"), /*#__PURE__*/React.createElement("tspan", {
    y: 174,
    fill: "#47b3eb"
  }, "/&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 200,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 200,
    fill: "#47b3eb"
  }, "&lt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 200
  }, "div "), /*#__PURE__*/React.createElement("tspan", {
    y: 200,
    fill: "#9846d8"
  }, "className"), /*#__PURE__*/React.createElement("tspan", {
    y: 200
  }, "=&apos;pl-20 pt-20 w-max pr-8&apos;"), /*#__PURE__*/React.createElement("tspan", {
    y: 200,
    fill: "#47b3eb"
  }, "&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 226,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 226,
    fill: "#47b3eb"
  }, "&lt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 226
  }, "p "), /*#__PURE__*/React.createElement("tspan", {
    y: 226,
    fill: "#9846d8"
  }, "className"), /*#__PURE__*/React.createElement("tspan", {
    y: 226
  }, "=&apos;font-bold mb-3&apos;&gt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 226,
    fill: "#cdc8d5"
  }, "Getting started"), /*#__PURE__*/React.createElement("tspan", {
    y: 226
  }, "&lt;/p"), /*#__PURE__*/React.createElement("tspan", {
    y: 226,
    fill: "#47b3eb"
  }, "&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 252,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 252,
    fill: "#47b3eb"
  }, "&lt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 252
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    y: 252,
    xmlSpace: "preserve",
    fill: "#9846d8"
  }, " className"), /*#__PURE__*/React.createElement("tspan", {
    y: 252
  }, "=&apos;text-[17px]&apos;&gt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 252,
    fill: "#cdc8d5"
  }, "Introduction"), /*#__PURE__*/React.createElement("tspan", {
    y: 252
  }, "&lt;/p"), /*#__PURE__*/React.createElement("tspan", {
    y: 252,
    fill: "#47b3eb"
  }, "&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 278,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 278,
    fill: "#47b3eb"
  }, "&lt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 278
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    y: 278,
    xmlSpace: "preserve",
    fill: "#9846d8"
  }, " className"), /*#__PURE__*/React.createElement("tspan", {
    y: 278
  }, "=&apos;text-[17px] text-blue-500&apos;&gt;"), /*#__PURE__*/React.createElement("tspan", {
    y: 278,
    fill: "#cdc8d5"
  }, "Overview"), /*#__PURE__*/React.createElement("tspan", {
    y: 278
  }, "&lt;/p"), /*#__PURE__*/React.createElement("tspan", {
    y: 278,
    fill: "#47b3eb"
  }, "&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 304,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 304,
    fill: "#47b3eb"
  }, "&lt;/"), /*#__PURE__*/React.createElement("tspan", {
    y: 304
  }, "div"), /*#__PURE__*/React.createElement("tspan", {
    y: 304,
    fill: "#47b3eb"
  }, "&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 330,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 330,
    fill: "#47b3eb"
  }, "&lt;/"), /*#__PURE__*/React.createElement("tspan", {
    y: 330
  }, "div"), /*#__PURE__*/React.createElement("tspan", {
    y: 330,
    fill: "#47b3eb"
  }, "&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 356,
    xmlSpace: "preserve"
  }, "  )"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 382
  }, "}"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 408
  })), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 434
  }, "export default"), /*#__PURE__*/React.createElement("tspan", {
    y: 434,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 434,
    fill: "#247fdb"
  }, "Menu"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeOverview01);
export default __webpack_public_path__ + "static/media/codeOverview01.b76e48a87094b4a24a2213c075547eb9.svg";
export { ForwardRef as ReactComponent };